
import Vue from "vue"
export default Vue.extend({
    props:{
        showModal:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return {
            modalVisible:false,
            fields:[
                {key:"selector",label:""},
                "subject",
                "timeSent"
            ],
            selectedNotifications:[] as Array<any>
        }
    },
    computed:{
        notifications():Array<any>{
            return  this.$store.getters["Notifications/getNotifications"]
        }
    },
    methods:{
        checkBoxSelectionChanged(notificationId:any){
            if(this.selectedNotifications.includes(notificationId)){
                this.selectedNotifications.splice(this.selectedNotifications.indexOf(notificationId),1)
            }else{
                this.selectedNotifications.push(notificationId)
            }
        }
    },
    watch:{
        showModal:{
            immediate:true,
            handler(){
                if(this.showModal){
                    this.$bvModal.show("notification-modal")
                    this.modalVisible = true
                }else{
                    if(this.modalVisible){
                        this.$bvModal.hide("notification-modal")
                        this.$emit("notification-modal-closed")
                        this.modalVisible = false
                    }
                }
            }
        }
    }
})
